import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import SystemSetting from './system-setting-model'
import {
  CreateSystemSettingAsync,
  DeleteSystemSettingAsync,
  LoadSystemSettingsAsync,
} from './systemSetting-thunk'
const initialState: systemSettingSliceState = {
  systemSetting: [],
  selected_systemSetting: '',
  is_loading_systemSetting: false,
  is_creating_systemSetting: false,
  is_deleting_systemSetting: false,
}
export interface systemSettingSliceState {
  systemSetting: SystemSetting[]
  selected_systemSetting?: string
  is_loading_systemSetting: boolean
  is_creating_systemSetting: boolean
  is_deleting_systemSetting: boolean
}
export const systemSettingSlice = createSlice({
  name: 'systemSetting',
  initialState,
  reducers: {
    setSelectedsystemSetting: (state, action) => {
      state.selected_systemSetting = action.payload
    },
    clearStatesystemSetting: (state) => {
      state.systemSetting = []
      state.is_loading_systemSetting = false
      state.is_creating_systemSetting = false
      state.is_deleting_systemSetting = false
    },
    mergesystemSetting: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_systemSetting = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.systemSetting = merge(state.systemSetting, payload) as any
        }
      }
    },

    add_systemSetting: (state, action) => {
      if (action.payload) {
        state.systemSetting = [...state.systemSetting, action.payload]
      }
    },
    set_systemSetting: (state, action) => {
      let { key, value, id } = action.payload
      state.systemSetting = state.systemSetting.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSystemSettingsAsync.pending, (state) => {
      state.is_loading_systemSetting = true
    })
    builder.addCase(LoadSystemSettingsAsync.fulfilled, (state, action) => {
      state.is_loading_systemSetting = false
      if (action.payload) {
        state.systemSetting = action.payload
      }
    })
    builder.addCase(LoadSystemSettingsAsync.rejected, (state) => {
      state.is_loading_systemSetting = false
    })
    builder.addCase(CreateSystemSettingAsync.pending, (state) => {
      state.is_creating_systemSetting = true
    })
    builder.addCase(CreateSystemSettingAsync.fulfilled, (state) => {
      state.is_creating_systemSetting = false
    })
    builder.addCase(CreateSystemSettingAsync.rejected, (state) => {
      state.is_creating_systemSetting = false
    })
    builder.addCase(DeleteSystemSettingAsync.pending, (state) => {
      state.is_deleting_systemSetting = true
    })
    builder.addCase(DeleteSystemSettingAsync.fulfilled, (state, action) => {
      state.is_deleting_systemSetting = false
      if (state.systemSetting) {
        state.systemSetting = state.systemSetting.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteSystemSettingAsync.rejected, (state) => {
      state.is_deleting_systemSetting = false
    })

    builder.addCase(autoThunks.fetch_system_settings.pending, (state) => {
      state.is_loading_systemSetting = true
    })
    builder.addCase(
      autoThunks.fetch_system_settings.fulfilled,
      (state, action) => {
        state.is_loading_systemSetting = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.fetch_system_settings.rejected, (state) => {
      state.is_loading_systemSetting = false
    })

    builder.addCase(autoThunks.save_system_settings.pending, (state) => {
      state.is_loading_systemSetting = true
    })
    builder.addCase(
      autoThunks.save_system_settings.fulfilled,
      (state, action) => {
        state.is_loading_systemSetting = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.save_system_settings.rejected, (state) => {
      state.is_loading_systemSetting = false
    })

    builder.addCase(autoThunks.get_system_settings.pending, (state) => {
      state.is_loading_systemSetting = true
    })
    builder.addCase(
      autoThunks.get_system_settings.fulfilled,
      (state, action) => {
        state.is_loading_systemSetting = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_system_settings.rejected, (state) => {
      state.is_loading_systemSetting = false
    })

    builder.addCase(
      autoThunks.set_current_release_zone_system_settings.pending,
      (state) => {
        state.is_loading_systemSetting = true
      },
    )
    builder.addCase(
      autoThunks.set_current_release_zone_system_settings.fulfilled,
      (state, action) => {
        state.is_loading_systemSetting = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.set_current_release_zone_system_settings.rejected,
      (state) => {
        state.is_loading_systemSetting = false
      },
    )

    builder.addCase(autoThunks.fetch_user_measurements.pending, (state) => {
      state.is_loading_systemSetting = true
    })
    builder.addCase(
      autoThunks.fetch_user_measurements.fulfilled,
      (state, action) => {
        state.is_loading_systemSetting = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.fetch_user_measurements.rejected, (state) => {
      state.is_loading_systemSetting = false
    })
  },
})

function handleResult(action: any, state: systemSettingSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_systemSetting = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.systemSetting = merge(state.systemSetting, payload) as any
    }
  }
}

export const {
  clearStatesystemSetting,
  setSelectedsystemSetting,
  set_systemSetting,
  mergesystemSetting,
  add_systemSetting,
} = systemSettingSlice.actions

export const get_systemSetting =
  (id?: string) =>
  (state: {
    systemSetting: {
      systemSetting: SystemSetting[]
    }
  }): SystemSetting | null => {
    let temp = state?.systemSetting?.systemSetting?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.systemSetting?.systemSetting[0] || null
  }
export const get_selected_systemSetting = (state: {
  systemSetting: systemSettingSliceState
}): SystemSetting | null => {
  let id = state?.systemSetting?.selected_systemSetting
  let temp = state?.systemSetting?.systemSetting?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_systemSetting = (state: {
  systemSetting: {
    systemSetting: SystemSetting[]
  }
}): SystemSetting[] => {
  let temp = state?.systemSetting?.systemSetting
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_systemSetting_busy = (state: {
  systemSetting: systemSettingSliceState
}) => {
  return (
    state?.systemSetting.is_deleting_systemSetting ||
    state?.systemSetting.is_loading_systemSetting ||
    state?.systemSetting.is_creating_systemSetting
  )
}
export const is_deleting_systemSetting_busy = (state: {
  systemSetting: systemSettingSliceState
}) => {
  return state?.systemSetting.is_deleting_systemSetting
}
export const is_loading_systemSetting_busy = (state: {
  systemSetting: systemSettingSliceState
}) => {
  return state?.systemSetting.is_loading_systemSetting
}
export const is_creating_systemSetting_busy = (state: {
  systemSetting: systemSettingSliceState
}) => {
  return state?.systemSetting.is_creating_systemSetting
}

export default systemSettingSlice.reducer
